function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Text } from "sprout-ui-primitives";
import AssignmentDialogUser from "./AssignmentDialogUser";
const AssignmentDialogUsers = (props)=>{
    const { users , getItemProps , onUserChange  } = props;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Text, {
                caps: true,
                color: "blue.40",
                fontSize: 1,
                fontWeight: "bold",
                mx: 1,
                mb: 1,
                children: "Assign"
            }),
            /*#__PURE__*/ _jsx(Box, {
                children: users.map((item, index)=>/*#__PURE__*/ _jsx(AssignmentDialogUser, _objectSpread({
                        user: item,
                        onUserChange: onUserChange
                    }, getItemProps({
                        index,
                        item
                    })), item.user.id))
            })
        ]
    });
};
export default AssignmentDialogUsers;
